<template>
    <div class="Submenu">

        <nav class="navbar navbar-expand-lg navbar-dark bg-dark submenu">
            <a class="navbar-brand" href="#"></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" 
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="nav navbar-nav mr-3 pb-1" v-for="f in menu" :key="f.id">
                    <li class="nav-item">
                        <a :class="{
                        'nav-link pointer' : f.id != menuActivo, 
                        'nav-linkS nav-link pointer': f.id == menuActivo}" 
                        @click="ir(f.href)">
                        <font-icon :icon="f.icono"/> 
                        <span>{{f.nombre}}</span>
                        <span class="badge badge-danger" v-if="f.id == 4 && numChats != 0">{{numChats}}</span>
                        </a>
                    </li>
                </ul>
                <form class="form-inline my-2 my-lg-0">
                </form>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name:'Submen',
    props:['menuActivo','url'],
    data(){
        return{
            clase:'nav-link',
            menu:[],
            rol: localStorage.rol,
            numChats: 0
        }
    },
    created: function() {
		var self = this;
        
        setInterval(function() {
          self.chatsSub()}, 1000*60)
          /*setInterval(
          self.chatsSub(), 1000);*/
    },
    
    mounted(){
        this.chatsSub();
        
        if(this.rol == 1)
        {
            this.menu = [
                {id:1,nombre:'Perfil',href:'/Perfil',icono:'user-cog'},
                {id:2,nombre:'Mis Proyectos',href:'/Proyectos',icono:'toolbox'},
                {id:4,nombre:'Conversaciones',href:'/Blog',icono:'comments'},
                {id:5,nombre:'Reseñas',href:'/Feedback',icono:'star-half-alt'}
                ]
        }
        else{
            this.menu = [
                {id:1,nombre:'Perfil',href:'/Perfil',icono:'user-cog'},
                {id:2,nombre:'Mis Propuestas',href:'/Proyectos',icono:'toolbox'},
                {id:3,nombre:'Buscar Proyectos',href:'/Buscar',icono:'search'},
                {id:4,nombre:'Conversaciones',href:'/Blog',icono:'comments'},
                {id:5,nombre:'Reseñas',href:'/Feedback',icono:'star-half-alt'},
                {id:6,nombre:'Membresía',href:'/Suscripcion',icono:'id-card'}
                ]
        }
    },

    methods:{
        ir(ruta){
            this.$router.push(ruta);
        },

        chatsSub(){

            let data = {
                flag: 5,
                id: localStorage.userID,
                rol: localStorage.rol
            }

            this.axios.post(this.url + 'getChat.php', data).then((responce) => {
                this.numChats = responce.data[0].msg;
            });
        },

    
    },

    
}
</script>

<style scoped>
.submenu{
    background-color: #0e1724;
    padding:5px;
    text-decoration: none !important;
}

.nav-link{
    color: white !important;
}

.nav-linkS{
    border-bottom: 1px solid orangered;
}

.nav-item:hover{
    background-color: #242729;
    border-radius: 10px;
}


</style>




// WEBPACK FOOTER //
// src/components/Submenu.vue